exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-bordered th, .table-bordered td {\r\n    border: none;\r\n}\r\n\r\n.table__row_static {\r\n    overflow-x: scroll;\r\n}\r\n\r\n.table__col {\r\n    padding: 0.75rem 0;\r\n    margin: 0 15px;\r\n}", ""]);

